import React, { useMemo } from "react";
const sparkleColors = ["#ff3aa2", "#ff5bad", "#a855f7", "#c084fc", "#35dceb", "#2dd4bf", "#a8ed36", "#facc15", "#ffffff"];
type Sparkle = {
  left: number;
  top: number;
  size: number;
  color: string;
  delay: number;
  duration: number;
  twinkle: boolean;
};
type GlitterSparklesProps = {
  /** Number of fine glitter specks. Larger areas look best with more. */
  count?: number;
};

/** Deterministic pseudo-random so the glitter pattern is stable between renders. */
function seeded(index: number): number {
  const value = Math.sin(index * 12.9898 + 78.233) * 43758.5453;
  return value - Math.floor(value);
}
function createSparkles(count: number): Sparkle[] {
  return Array.from({
    length: count
  }, (_, index) => {
    const sizeRoll = seeded(index + 3000);
    return {
      left: seeded(index) * 100,
      top: seeded(index + 1000) * 100,
      size: sizeRoll > 0.92 ? 3 : sizeRoll > 0.6 ? 2 : 1,
      color: sparkleColors[Math.floor(seeded(index + 2000) * sparkleColors.length)],
      delay: seeded(index + 4000) * 4,
      duration: 1.6 + seeded(index + 5000) * 2.4,
      twinkle: seeded(index + 6000) > 0.55
    };
  });
}

/** Multicolored twinkling glitter layer. Place inside a `relative` container; it sits behind content and ignores clicks. */
export function GlitterSparkles({
  count = 140
}: GlitterSparklesProps) {
  const sparkles = useMemo(() => createSparkles(count), [count]);
  return <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true" data-id="element-205" data-mp="37xwr7rsi4ihj">
      {sparkles.map((sparkle, index) => <span key={index} className={`absolute rounded-full ${sparkle.twinkle ? "glitter-sparkle-twinkle" : ""}`} style={{
      left: `${sparkle.left}%`,
      top: `${sparkle.top}%`,
      width: sparkle.size,
      height: sparkle.size,
      backgroundColor: sparkle.color,
      opacity: sparkle.twinkle ? undefined : 0.55,
      boxShadow: sparkle.size >= 2 ? `0 0 3px ${sparkle.color}` : undefined,
      animationDelay: `${sparkle.delay}s`,
      animationDuration: `${sparkle.duration}s`
    }} data-id="element-206" data-mp="3hujawd93d3hz" data-mpi={index} />)}
    </div>;
}